import clsx from 'clsx';

import styled from '@emotion/styled';

import { capitalize, formatForStatus } from '../../utils/utils';

interface StatusCellProps {
  data?: Record<string, any>;
  statusKey?: string;
  plain?: boolean;
  customClasses?: string;
  useBoolean?: boolean;
}

const StatusCell: React.FC<StatusCellProps> = ({
  data,
  statusKey,
  plain = false,
  customClasses,
  useBoolean,
}) => {
  let label = data && data[statusKey ?? ''];

  if (!label && !useBoolean) {
    label = statusKey;
  }

  // Normalize backend status value
  if (label === 'IN_WAREHOUSE') {
    label = 'AT_WAREHOUSE';
  }

  if (label === 'PENDING') {
    label = 'PROCESSING_CLEARANCE';
  }

  if (data && typeof data['status'] === 'boolean') {
    label = Boolean(data['status']) ? ' active' : 'inactive';
  }

  let formatStatus = formatForStatus(String(label) ?? '');

  if (plain) {
    formatStatus = label.replace(/_/g, ' ');
  }

  return (
    <StatusCellWrapper
      className={clsx(
        `${formatForStatus(String(label) ?? '')} status`,
        customClasses
      )}
    >
      {capitalize(formatStatus)}
    </StatusCellWrapper>
  );
};

export default StatusCell;

const StatusCellWrapper = styled.div`
  display: flex;
  background-color: yellow;
  width: fit-content;
  line-height: 20px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  padding: 8px !important;
  margin-left: 16px;
  user-select: none;
  height: fit-content;

  &.draft {
    color: #4b5563;
    background-color: #f9fafb;
    border: 1px solid ${({ theme }) => theme.palette.darkestBorderColor};
  }

  &.false,
  &.cleared,
  &.inactive {
    color: #ca8a04;
    background-color: #fefce8;
    border: 1px solid #fb923c;
  }

  &.checkout-ready,
  &.partially-cleared,
  &.in-storage,
  &.scheduled,
  &.delivered,
  &.approved,
  &.testing-for-now,
  &.true,
  &.processing-clearance,
  &.active {
    color: #16a34a;
    background-color: #f0fdf4;
    border: 1px solid #4ade80;
  }

  &.scheduled,
  &.open,
  &.last-mile,
  &.on-the-way,
  &.high-value,
  &.mobile-storage,
  &.return-to-origin,
  &.out-of-storage,
  &.out-for-delivery {
    color: #2563eb;
    background-color: #eff6ff;
    border: 1px solid #60a5fa;
  }

  &.in-warehouse,
  &.at-warehouse,
  &.storage {
    color: #9333ea;
    background-color: #faf5ff;
    border: 1px solid #9333ea;
  }

  &.pending,
  &.cancelled,
  &.declined,
  &.false,
  &.with-issues,
  &.withheld {
    color: #dc2626;
    background-color: #fef2f2;
    border: 1px solid #fca5a5;
  }

  &.unassigned {
    color: #4b5563;
    background-color: #f9fafb;
    border: 1px solid ${({ theme }) => theme.palette.darkestBorderColor};
  }
`;
